import React, { createContext, useContext, useState } from 'react'

/**
 * Provides two DOM slots for TTS UI: button (next to byline) and expanded player (below byline).
 * ArticleBlockContent portals into these so all TTS state stays in one place (no state context).
 */
export interface ArticleTtsSlotContextValue {
    buttonSlotElement: HTMLDivElement | null
    setButtonSlotElement: (el: HTMLDivElement | null) => void
    expandedPlayerSlotElement: HTMLDivElement | null
    setExpandedPlayerSlotElement: (el: HTMLDivElement | null) => void
}

const noop = () => {}
const defaultValue: ArticleTtsSlotContextValue = {
    buttonSlotElement: null,
    setButtonSlotElement: noop,
    expandedPlayerSlotElement: null,
    setExpandedPlayerSlotElement: noop,
}

export const ArticleTtsSlotContext =
    createContext<ArticleTtsSlotContextValue>(defaultValue)

export function useArticleTtsSlot(): ArticleTtsSlotContextValue {
    return useContext(ArticleTtsSlotContext)
}

export function ArticleTtsSlotProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [buttonSlotElement, setButtonSlotElement] =
        useState<HTMLDivElement | null>(null)
    const [expandedPlayerSlotElement, setExpandedPlayerSlotElement] =
        useState<HTMLDivElement | null>(null)
    return (
        <ArticleTtsSlotContext.Provider
            value={{
                buttonSlotElement,
                setButtonSlotElement,
                expandedPlayerSlotElement,
                setExpandedPlayerSlotElement,
            }}
        >
            {children}
        </ArticleTtsSlotContext.Provider>
    )
}
